/* ==========================================================================
   Blanket Statement — motion behaviour
   <script src="{{ 'bs-motion.js' | asset_url }}" defer></script>

   Handles: cart wiggle reminder, add-to-cart feedback, fly-to-cart,
   pointer-tracked button highlight, and tilt on hover.
   Everything degrades to nothing if JS or motion is unavailable.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Tunables — all overridable via window.BS_MOTION before this file loads. */
  var CFG = Object.assign({
    cartSelectors: [
      '[data-bs-cart-icon]',
      '#cart-icon-bubble',
      '.header__icon--cart',
      'a[href$="/cart"]'
    ],
    bubbleSelectors: ['.cart-count-bubble', '[data-bs-cart-count]'],
    firstReminderMs: 25000,   // first nudge after the page settles
    repeatReminderMs: 60000,  // then once a minute
    maxReminders: 3,          // then stop. a wiggle that never quits is a bug
    flyToCart: true
  }, window.BS_MOTION || {});

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }

  function cartIcon() {
    for (var i = 0; i < CFG.cartSelectors.length; i++) {
      var el = $(CFG.cartSelectors[i]);
      if (el) return el;
    }
    return null;
  }

  function cartBubble() {
    for (var i = 0; i < CFG.bubbleSelectors.length; i++) {
      var el = $(CFG.bubbleSelectors[i]);
      if (el) return el;
    }
    return null;
  }

  function once(el, cls, ms) {
    if (!el || REDUCED) return;
    el.classList.remove(cls);
    void el.offsetWidth;              // restart the animation
    el.classList.add(cls);
    setTimeout(function () { el.classList.remove(cls); }, ms);
  }

  /* ---- Cart state ---------------------------------------------------- */

  var reminders = 0;
  var timer = null;
  var cartOpened = false;

  function cartCount() {
    var b = cartBubble();
    if (b) {
      var n = parseInt((b.textContent || '').replace(/\D/g, ''), 10);
      if (!isNaN(n)) return n;
      if (b.offsetParent !== null) return 1;   // Dawn shows a dot with no number
    }
    return 0;
  }

  function wiggle() {
    var icon = cartIcon();
    if (!icon) return;
    once(icon, 'bs-cart-wiggle', 760);
    once(icon, 'bs-cart-halo', 940);
  }

  function scheduleReminders() {
    clearTimeout(timer);
    if (REDUCED || cartOpened) return;
    if (reminders >= CFG.maxReminders) return;
    if (cartCount() < 1) return;

    var delay = reminders === 0 ? CFG.firstReminderMs : CFG.repeatReminderMs;
    timer = setTimeout(function () {
      // Don't nudge someone who isn't looking, or who is mid-checkout.
      if (document.hidden || /\/(cart|checkouts?)\b/.test(location.pathname)) {
        scheduleReminders();
        return;
      }
      reminders++;
      wiggle();
      scheduleReminders();
    }, delay);
  }

  /* ---- Add-to-cart feedback ------------------------------------------ */

  function flyToCart(sourceEl, imageUrl) {
    if (!CFG.flyToCart || REDUCED || !sourceEl) return;
    var icon = cartIcon();
    if (!icon) return;

    var from = sourceEl.getBoundingClientRect();
    var to   = icon.getBoundingClientRect();
    var ghost = document.createElement('div');
    ghost.className = 'bs-fly';
    if (imageUrl) ghost.style.backgroundImage = 'url("' + imageUrl + '")';
    ghost.style.left = from.left + from.width / 2 - 26 + 'px';
    ghost.style.top  = from.top  + from.height / 2 - 26 + 'px';
    document.body.appendChild(ghost);

    requestAnimationFrame(function () {
      var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
      var dy = (to.top  + to.height / 2) - (from.top  + from.height / 2);
      ghost.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.28) rotate(12deg)';
      ghost.style.opacity = '0.1';
    });
    setTimeout(function () { ghost.remove(); }, 660);
  }

  function onAdded(detail) {
    reminders = 0;                        // fresh add resets the nag budget
    var btn = detail && detail.button;
    if (btn && btn.dataset.bsBusy === '1') btn = null;   // already animating
    if (btn) {
      btn.dataset.bsBusy = '1';
      flyToCart(btn, detail.image);
      var label = btn.dataset.bsLabel || btn.textContent.trim();
      btn.dataset.bsLabel = label;
      btn.classList.add('is-added');
      btn.textContent = btn.dataset.bsAddedText || 'Added';
      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.textContent = label;
        delete btn.dataset.bsBusy;
      }, 1800);
    }
    setTimeout(function () {
      wiggle();
      once(cartBubble(), 'bs-bubble-pop', 440);
      scheduleReminders();
    }, btn ? 480 : 0);
  }

  // Public hook so the customizer (and any theme code) can announce an add.
  window.bsCartAdded = onAdded;

  /* Remember which button started an add. document.activeElement is
     unreliable here: Safari doesn't focus buttons on click, and a theme may
     move focus into a cart drawer before the request resolves. */
  var lastAddButton = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest(
      'button[name="add"], [data-bs-add], .product-form__submit, .bs-btn[type="submit"]'
    );
    if (b) { lastAddButton = b; setTimeout(function () { lastAddButton = null; }, 6000); }
  }, true);

  /* Intercept Shopify's cart endpoints so this works with Dawn's own
     add-to-cart, quick-add, and the custom customizer alike. */
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      // Matches /cart/add.js, cart/add, and locale-prefixed /en-us/cart/add.js
      var isAdd = /(^|\/)cart\/add(\.js)?(\?|$)/.test(url.split('#')[0]);
      return origFetch.apply(this, arguments).then(function (res) {
        if (isAdd && res.ok) {
          var btn = lastAddButton;
          if (!btn) {
            var active = document.activeElement;
            if (active && active.matches && active.matches('button, .bs-btn')) btn = active;
          }
          onAdded({ button: btn });
          lastAddButton = null;
        }
        return res;
      });
    };
  }

  // Dawn / Shopify theme events
  document.addEventListener('cart:updated', function () { scheduleReminders(); });
  document.addEventListener('cart-drawer:open', function () { cartOpened = true; clearTimeout(timer); });

  /* ---- Pointer-tracked highlight on primary buttons ------------------- */

  function trackPointer(e) {
    var r = this.getBoundingClientRect();
    this.style.setProperty('--bs-mx', ((e.clientX - r.left) / r.width  * 100) + '%');
    this.style.setProperty('--bs-my', ((e.clientY - r.top)  / r.height * 100) + '%');
  }

  /* ---- Tilt: card leans very slightly toward the cursor --------------- */

  function tilt(e) {
    var r = this.getBoundingClientRect();
    var px = (e.clientX - r.left) / r.width  - .5;
    var py = (e.clientY - r.top)  / r.height - .5;
    var max = parseFloat(this.dataset.bsTilt || '4');
    this.style.transform =
      'translateY(-6px) perspective(900px) rotateX(' + (-py * max) + 'deg) rotateY(' + (px * max) + 'deg)';
  }
  function untilt() { this.style.transform = ''; }

  /* ---- Init ----------------------------------------------------------- */

  function init() {
    if (!REDUCED) {
      document.querySelectorAll('.bs-btn--primary').forEach(function (b) {
        b.addEventListener('pointermove', trackPointer);
      });
      document.querySelectorAll('[data-bs-tilt]').forEach(function (c) {
        c.addEventListener('pointermove', tilt);
        c.addEventListener('pointerleave', untilt);
      });
    }
    // Clicking the cart ends the reminders for this page.
    var icon = cartIcon();
    if (icon) icon.addEventListener('click', function () { cartOpened = true; clearTimeout(timer); });

    scheduleReminders();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) scheduleReminders();
  });
})();
